import { action, makeAutoObservable, makeObservable, observable } from "mobx"
import { ProgStatus } from "../models/utilTypes"
import ApiService from "../services/ApiService"
import * as Base64_Blob from 'base64-blob'
import { rootStore } from "../StApp"
import AppCrypto from "../services/CryptoService"
import { CheckInviteResponse } from "../models/api/CheckInviteResponse"

export default class RegistrationStore{

    userName: string = ''
    password: string = ''
    confirmPassword: string = ''
    regProgress: ProgStatus = 'INIT'
    sex: string = 'F'
    inviteCode: string = ''
    api = ApiService
    inviteProg: ProgStatus = 'INIT'
    validateInviteResp: CheckInviteResponse| null = null
    
    constructor(){

        makeObservable(this, {
            regProgress: observable,
            password: observable,
            confirmPassword: observable,
            inviteProg: observable
         })

    }

    async registerAnonymously(voiceIntroBlob?: Blob ){

        //const blobData = await Base64_Blob.blobToBase64(voiceIntroBlob!)
        this.regProgress = 'LOADING'
        AppCrypto.generateKeys()
        this.api.registerUser({
            userId: this.userName.toLowerCase().trim(), 
            pass: this.password.trim(), 
            vIntro: '', 
            pubKey: AppCrypto.publicKey!, 
            privKey: AppCrypto.privateKey!,
            sex: this.sex,
            invite: this.inviteCode,
            uid: rootStore.mainStore.uid?? undefined,
            auth: rootStore.mainStore.token?? undefined            
         }).then(result=>{
                rootStore.mainStore.setLoggedInUser({
                    userId: this.userName.toLowerCase().trim(),
                    uid: result.data.uid,
                    token: result.data.token
                })
                this.regProgress = 'SUCCESS'
                console.log(result)
            })
            .catch(err=>{
                AppCrypto.dumpKeys()
            })
    }

    setUserName(data: string){
        this.userName = data
    }

    setSex(data: string){
        this.sex = data
    }
    setInviteCode(data: string){
        if(this.inviteProg != 'INIT')
         this.inviteProg = 'INIT'
        this.inviteCode = data
        if(data.length == 6)
         this.validateInviteCode()
        
    }

    @action
    setPassword(data: string){
        this.password = data
    }

    @action
    setConfirmPassword(data: string){
        this.confirmPassword = data
    }

    private validateInviteCode(){
        this.inviteProg = 'LOADING'
        this.api.checkInviteCode({invite: this.inviteCode})
        .then(resp=>{
            if(resp.status == 200){
             this.validateInviteResp = resp.data
             this.inviteProg = 'SUCCESS'
            }
        })
        .catch(err=>{
            this.inviteProg = 'FAILED'
            console.error(err)
        })
    }


}